/*!

=========================================================
* Black SalesDashboard React v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import moment from 'moment';
// nodejs library that concatenates classes
import classNames from "classnames";
// react plugin used to create charts

// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";
import PerfectScrollbar from 'perfect-scrollbar';
import SalesChart from "components/Charts/SalesChart";
import AppointmentChart from "components/Charts/AppointmentChart"
import SystemSizeChart from "components/Charts/SystemSizeChart"
import PaymentChart from "components/Charts/PaymentChart";
import FollowupTable from "components/Tables/FollowupTable";
import FollowupSoldTable from "components/Tables/FollowupSoldTable";
import SalesTimeframeTable from "components/Tables/SalesTimeframeTable";
import TimeframePicker from "components/Charts/TimeframePicker";
import {teamService} from "services/team.service";
import {chartService} from "../services";

var ps;

class SalesDashboard extends React.Component {
  constructor(props) {
    super(props);
    var ds = new Date()
    ds.setHours(0);
    ds.setMinutes(0);
    ds.setSeconds(0);
    var de = new Date();
    de.setHours(23);
    de.setMinutes(59);
    de.setSeconds(59);
    this.state = {
      salesData: [],
      appointmentData: [],
      reps: [],
      salesAction: 'all',
      salesType: 'value',
      appointmentAction: 'all',
      notWonAction: 7,
      salesTFAction: 'all',
      paymentTypeAction: 'count',
      TeamData: [],
      DateStart: ds,
      DateEnd: de,
      Interval: 'hours'
    };
    this.formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'AUD',
    });
    this.mainPanel = React.createRef();
  }

  componentDidMount() {
    // if(navigator.platform.indexOf('Win') > -1){
    //   ps = new PerfectScrollbar(this.mainPanel);
    // }
    teamService.getAllTeams().then(resp => {
      this.setState({TeamData: resp})
    });
    this.refreshChartData();
  }
  componentWillUnmount(){
    // if(navigator.platform.indexOf('Win') > -1){
    //   ps.destroy();
    // }
  }

  onUpdateChart = (obj) => {
    this.setState({DateStart: obj.start, DateEnd: obj.end, Interval: obj.interval}, this.refreshChartData)
  }

  refreshChartData = () => {
    const {DateStart, DateEnd, Interval} = this.state;
    chartService.getSalesChart(moment(DateStart).format('YYYY-MM-DD 00:00:00+10'), moment(DateEnd).format('YYYY-MM-DD 23:59:59+10')).then(resp => {
      this.setState({salesData: resp})
    })
    chartService.getAppointmentChart(moment(DateStart).format('YYYY-MM-DD 00:00:00+10'), moment(DateEnd).format('YYYY-MM-DD 23:59:59+10')).then(resp => {
      this.setState({appointmentData: resp})
    })
  }

  getSalesTotalValue = () => {
    const {salesData} = this.state;
    var sum = 0;
    for (var i = 0; i < salesData.length; i++) {
      sum += salesData[i].DealValue;
    }
    return this.formatter.format(sum);
  }

  getAvgSystemSize = () => {
    if (this.state.salesData.length == 0) {
      return "- kw"
    }
    var total = 0;
    this.state.salesData.forEach(i => {
      total += Number(i.SystemSize.replace(/[^0-9\.]+/g,""));
    })
    return parseInt((total / this.state.salesData.length) * 100) / 100 + " kw";
  }

  getFollowUpValue = () => {
    var total = 0;
    var processed = [];
    var soldIDS = [];
    this.state.salesData.forEach(i => {
      if (soldIDS.indexOf(i.DealID) === -1) {
        soldIDS.push(i.DealID);
      }
    })
    this.state.appointmentData.forEach(i => {
      //we havent counted it AND its not sold already
      if (processed.indexOf(i.DealID) === -1 && soldIDS.indexOf(i.DealID) === -1) {
        total += i.DealValue;
        processed.push(i.DealValue)
      }
    })
    return this.formatter.format(total)
  }

  getFollowUpSoldValue = () => {
    var soldIDS = [];
    this.state.salesData.forEach(i => {
      if (soldIDS.indexOf(i.DealID) === -1) {
        soldIDS.push(i.DealID);
      }
    });
    var total = 0;
    var processed = [];
    this.state.appointmentData.forEach(a => {
      if (soldIDS.indexOf(a.DealID) != -1 && processed.indexOf(a.DealID) == -1) {
        total += a.DealValue;
        processed.push(a.DealID)
      }
    })
    return this.formatter.format(total)
  }


  render() {
    return (
      <>
        <div className="content" ref={this.mainPanel}>
          <Row>
            <Col xs={12}>
              <Card>
                <CardHeader>
                  <h4>Reporting Timeframe</h4>
                </CardHeader>
                <CardBody>
                  <TimeframePicker intervals={["hours", "daily", "weekly", "monthly"]} onUpdateChart={this.onUpdateChart}/>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            {/* SALES CHART */}
            <Col xs="12">
              <Card className="card-chart">
                <CardHeader>
                  <Row>
                    <Col className="text-left" sm="6">
                      <h5 className="card-category">Total Sales</h5>
                      <CardTitle tag="h2">{this.getSalesTotalValue() + " ( "+this.state.salesData.length+" Total Sales)"}</CardTitle>
                    </Col>
                    <Col sm="6">
                      <Row>
                        <Col xs={12}>
                          <ButtonGroup
                              className="btn-group-toggle float-right"
                              data-toggle="buttons"
                          >
                            <Button
                                tag="label"
                                className={classNames("btn-simple", {
                                  active: this.state.salesType === "value"
                                })}
                                color="info"
                                id="0"
                                size="sm"
                                onClick={() => this.setState({salesType: 'value'})}
                            >
                              <input
                                  defaultChecked
                                  className="d-none"
                                  name="options"
                                  type="radio"
                              />
                              <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                                Value
                              </span>
                              <span className="d-block d-sm-none">
                                <i className="tim-icons icon-single-02" />
                              </span>
                            </Button>
                            <Button
                                tag="label"
                                className={classNames("btn-simple", {
                                  active: this.state.salesType === "count"
                                })}
                                color="info"
                                id="0"
                                size="sm"
                                onClick={() => this.setState({salesType: 'count'})}
                            >
                              <input
                                  defaultChecked
                                  className="d-none"
                                  name="options"
                                  type="radio"
                              />
                              <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                                Count
                              </span>
                              <span className="d-block d-sm-none">
                                <i className="tim-icons icon-single-02" />
                              </span>
                            </Button>
                          </ButtonGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <ButtonGroup
                              className="btn-group-toggle float-right"
                              data-toggle="buttons"
                          >
                            <Button
                                tag="label"
                                className={classNames("btn-simple", {
                                  active: this.state.salesAction === "all"
                                })}
                                color="info"
                                id="0"
                                size="sm"
                                onClick={() => this.setState({salesAction: 'all'})}
                            >
                              <input
                                  defaultChecked
                                  className="d-none"
                                  name="options"
                                  type="radio"
                              />
                              <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                                Total
                              </span>
                              <span className="d-block d-sm-none">
                                <i className="tim-icons icon-single-02" />
                              </span>
                            </Button>
                            <Button
                                tag="label"
                                className={classNames("btn-simple", {
                                  active: this.state.salesAction === "rep"
                                })}
                                color="info"
                                id="0"
                                size="sm"
                                onClick={() => this.setState({salesAction: 'rep'})}
                            >
                              <input
                                  defaultChecked
                                  className="d-none"
                                  name="options"
                                  type="radio"
                              />
                              <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                                By Rep
                              </span>
                              <span className="d-block d-sm-none">
                                <i className="tim-icons icon-single-02" />
                              </span>
                            </Button>
                            <Button
                                tag="label"
                                className={classNames("btn-simple", {
                                  active: this.state.salesAction === "state"
                                })}
                                color="info"
                                id="0"
                                size="sm"
                                onClick={() => this.setState({salesAction: 'state'})}
                            >
                              <input
                                  defaultChecked
                                  className="d-none"
                                  name="options"
                                  type="radio"
                              />
                              <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                                By State
                              </span>
                              <span className="d-block d-sm-none">
                                <i className="tim-icons icon-single-02" />
                              </span>
                            </Button>
                          </ButtonGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <div>
                      <SalesChart reps={this.state.TeamData} view={this.state.salesAction} type={this.state.salesType} data={this.state.salesData} interval={this.state.Interval} dateStart={this.state.DateStart} dateEnd={this.state.DateEnd}/>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* APPOINTMENT CHART */}
            <Col xs="9">
              <Card className="card-chart">
                <CardHeader>
                  <Row>
                    <Col className="text-left" sm="6">
                      <h5 className="card-category">Appointments Sat</h5>
                      <CardTitle tag="h2">Sat: { (this.state.appointmentData.filter(i => i.LogType == 2)).length}</CardTitle>
                    </Col>
                    <Col sm="6">
                      <ButtonGroup
                          className="btn-group-toggle float-right"
                          data-toggle="buttons"
                      >
                        <Button
                            tag="label"
                            className={classNames("btn-simple", {
                              active: this.state.appointmentAction === "all"
                            })}
                            color="info"
                            id="0"
                            size="sm"
                            onClick={() => this.setState({appointmentAction: 'all'})}
                        >
                          <input
                              defaultChecked
                              className="d-none"
                              name="options"
                              type="radio"
                          />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            Total
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-single-02" />
                          </span>
                        </Button>
                        <Button
                            tag="label"
                            className={classNames("btn-simple", {
                              active: this.state.appointmentAction === "rep"
                            })}
                            color="info"
                            id="0"
                            size="sm"
                            onClick={() => this.setState({appointmentAction: 'rep'})}
                        >
                          <input
                              defaultChecked
                              className="d-none"
                              name="options"
                              type="radio"
                          />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            By Rep
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-single-02" />
                          </span>
                        </Button>
                        <Button
                            tag="label"
                            className={classNames("btn-simple", {
                              active: this.state.appointmentAction === "state"
                            })}
                            color="info"
                            id="0"
                            size="sm"
                            onClick={() => this.setState({appointmentAction: 'state'})}
                        >
                          <input
                              defaultChecked
                              className="d-none"
                              name="options"
                              type="radio"
                          />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            By State
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-single-02" />
                          </span>
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <AppointmentChart reps={this.state.TeamData} view={this.state.appointmentAction} interval={this.state.Interval} dateStart={this.state.DateStart} dateEnd={this.state.DateEnd} data={this.state.appointmentData}/>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* SYSTEM SIZE CHART */}
            <Col xs="3">
              <Card className="card-chart">
                <CardHeader>
                  <Row>
                    <Col className="text-left" sm="12">
                      <h5 className="card-category">System Size</h5>
                      <CardTitle tag="h2">Avg: &nbsp;{this.getAvgSystemSize()}
                      </CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <SystemSizeChart reps={this.state.reps} data={this.state.salesData}/>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* Payment Methods */}
            <Col xs="3">
              <Card className="card-chart">
                <CardHeader>
                  <Row>
                    <Col className="text-left" sm="6">
                      <h5 className="card-category">Payment Types</h5>
                      <CardTitle tag="h2">&nbsp;</CardTitle>
                    </Col>
                    <Col sm={6}>
                      <ButtonGroup
                          className="btn-group-toggle float-right"
                          data-toggle="buttons"
                      >
                        <Button
                            tag="label"
                            className={classNames("btn-simple", {
                              active: this.state.paymentTypeAction === "count"
                            })}
                            color="info"
                            id="0"
                            size="sm"
                            onClick={() => this.setState({paymentTypeAction: 'count'})}
                        >
                          <input
                              defaultChecked
                              className="d-none"
                              name="options"
                              type="radio"
                          />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                                Count
                              </span>
                          <span className="d-block d-sm-none">
                                <i className="tim-icons icon-single-02" />
                              </span>
                        </Button>
                        <Button
                            tag="label"
                            className={classNames("btn-simple", {
                              active: this.state.paymentTypeAction === "value"
                            })}
                            color="info"
                            id="0"
                            size="sm"
                            onClick={() => this.setState({paymentTypeAction: 'value'})}
                        >
                          <input
                              defaultChecked
                              className="d-none"
                              name="options"
                              type="radio"
                          />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                                Value
                              </span>
                          <span className="d-block d-sm-none">
                                <i className="tim-icons icon-single-02" />
                              </span>
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <PaymentChart reps={this.state.TeamData} view={this.state.paymentTypeAction} data={this.state.salesData}/>
                  </div>
                </CardBody>
              </Card>
            </Col>


            {/* FOLLOW UP TABLE */}
            <Col xs="3">
              <Card className="card-table">
                <CardHeader>
                  <Row>
                    <Col className="text-left" sm="12">
                      <h5 className="card-category">Follow Up</h5>
                      <CardTitle tag="h2">Value: {this.getFollowUpValue()}</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <div className="table-area">
                    <FollowupTable salesData={this.state.salesData} appointmentData={this.state.appointmentData}/>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* FOLLOW UP SOLD TABLE */}
            <Col xs="3">
              <Card className="card-table">
                <CardHeader>
                  <Row>
                    <Col className="text-left" sm="12">
                      <h5 className="card-category">Follow Up Sold</h5>
                      <CardTitle tag="h2">Value: {this.getFollowUpSoldValue()}</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <div className="table-area">
                    <FollowupSoldTable repData={this.state.TeamData} salesData={this.state.salesData} appointmentData={this.state.appointmentData}/>
                  </div>
                </CardBody>
              </Card>
            </Col>

            {/* sales Timeframe TABLE */}
            <Col xs="3">
              <Card className="card-table">
                <CardHeader>
                  <Row>
                    <Col className="text-left" sm="6">
                      <h5 className="card-category">AVG Sales</h5>
                      <CardTitle tag="h2">&nbsp;</CardTitle>
                    </Col>
                    <Col sm="6">
                      <ButtonGroup
                          className="btn-group-toggle float-right"
                          data-toggle="buttons"
                      >
                        <Button
                            tag="label"
                            className={classNames("btn-simple", {
                              active: this.state.salesTFAction === 'all'
                            })}
                            color="info"
                            id="0"
                            size="sm"
                            onClick={() => this.setState({salesTFAction: 'all'})}
                        >
                          <input
                              defaultChecked
                              className="d-none"
                              name="options"
                              type="radio"
                          />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            All
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-single-02" />
                          </span>
                        </Button>
                        <Button
                            tag="label"
                            className={classNames("btn-simple", {
                              active: this.state.salesTFAction === 'rep'
                            })}
                            color="info"
                            id="0"
                            size="sm"
                            onClick={() => this.setState({salesTFAction: 'rep'})}
                        >
                          <input
                              defaultChecked
                              className="d-none"
                              name="options"
                              type="radio"
                          />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            Rep
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-single-02" />
                          </span>
                        </Button>
                        <Button
                            tag="label"
                            className={classNames("btn-simple", {
                              active: this.state.salesTFAction === 'state'
                            })}
                            color="info"
                            id="0"
                            size="sm"
                            onClick={() => this.setState({salesTFAction: 'state'})}
                        >
                          <input
                              defaultChecked
                              className="d-none"
                              name="options"
                              type="radio"
                          />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            State
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-single-02" />
                          </span>
                        </Button>
                        <Button
                            tag="label"
                            className={classNames("btn-simple", {
                              active: this.state.salesTFAction === 'ls'
                            })}
                            color="info"
                            id="0"
                            size="sm"
                            onClick={() => this.setState({salesTFAction: 'ls'})}
                        >
                          <input
                              defaultChecked
                              className="d-none"
                              name="options"
                              type="radio"
                          />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            LS
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-single-02" />
                          </span>
                        </Button>
                      </ButtonGroup>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <div className="table-area">
                    <SalesTimeframeTable data={this.state.salesData} reps={this.state.TeamData} view={this.state.salesTFAction} />
                  </div>
                </CardBody>
              </Card>
            </Col>






          </Row>
        </div>
      </>
    );
  }
}

export default SalesDashboard;
